import React, { useEffect, useState, } from "react";

export default function About() {
  const [isOpen, setIsOpen] = useState(false);

  const precios = [
    {
      categoria: "General",
      normal: 280,
      preventa: 210,
      fechas: {
        normal: "01 nov - 13 nov",
        preventa: "10 sept - 16 oct"
      }
    },
    {
      categoria: "Socios (20% desc.)",
      normal: 224,
      preventa: 168,
      fechas: {
        normal: "01 nov - 13 nov",
        preventa: "10 sept - 16 oct"
      }
    },
    {
      categoria: "Estudiantes",
      normal: 80,
      preventa: 80,
      fechas: {
        normal: "01 nov - 13 nov",
        preventa: "10 sept - 16 oct"
      }
    }
  ];
  return (
    <>
      {/* <hr className="arequipa-hr" /> */}
      {/* <section className="about">
        <img src="/images/background2.png" alt="Fondo" className="about-bg" />

        <div className="about-container">
          <div className="title">
            <h2 style={{ color: "#fff" }}>
              ¿Qué ganas <br /> al caminar <br /> con nosotras?
            </h2>
          </div>
          <div className="text">
            <p style={{ color: "#fff" }}>
              Porque cuando una mujer crece, crecemos todas. <br />
              Porque tus sueños también merecen volverse posibles. <br />
              Porque cuando nos acompañamos, el camino se vuelve más liviano,
              la fuerza se multiplica y la libertad florece. <br />
              Porque juntas no solo crecemos, nos transformamos.
            </p>
          </div>
        </div>
      </section> */}

      <section className="about">
        <div className="about-container">
          <div className="title">
            <h2 style={{ color: "#444f69" }}>
              Este evento fue creado para mujeres líderes, <br />soñadoras y hacedoras que buscan:
            </h2>
          </div>
        </div>
      </section>

      <section className="learn">
        <div className="learn-container">
          <img src="/images/conmu1.jpg" alt="Imagen izquierda" className="learn-img" />

          <div className="learn-text">
            <div className="timeline">
              <div className="timeline-item">
                <span className="dot"></span>
                <p>Aprender de mujeres que ya lo hicieron posible.</p>
              </div>
              <div className="timeline-item">
                <span className="dot"></span>
                <p>Conectar con mujeres que se atrevieron a transformar su vida.</p>
              </div>
              <div className="timeline-item">
                <span className="dot"></span>
                <p>Crear redes de apoyo y colaboración. Vienes a expandirte.</p>
              </div>
            </div>
          </div>

          <img src="/images/conmu2.jpg" alt="Imagen derecha" className="learn-img" />
        </div>
      </section>


      {/* <hr className="arequipa-hr" /> */}
      <section className="arequipa">

        <div className="arequipa-left">
          <img src="/images/arequipa3.png" alt="Fondo" className="about-bg" />
        </div>

        <div className="arequipa-right">
          <h1>
            <span className="hashtag">#ConMujeres</span><br />
            presente en<br />
            Arequipa
            <hr />
          </h1>
          <p className="text">
            La tierra de los volcanes y del coraje.<br />
            En esta ciudad, donde cada amanecer abraza con su historia y cada calle respira tradición, nos encontramos para compartir, aprender y crecer juntas.
 <br />
            ConMujeres 2025 llegó con alma y fuerza a esta tierra que, con su calor humano, su sabor auténtico y la determinación de sus mujeres, inspira a construir un liderazgo con propósito. <br />
            Este encuentro no solo deja ideas, deja la certeza de que cuando las mujeres se unen, el cambio se siente… y permanece.<br />
            Gracias, Arequipa, tierra de mujeres que inspiran con su valentía.
ConMujeres 2025<br />
            #ConMujeres
          </p>
        </div>
      </section>

      {/* <hr className="arequipa-hr" /> */}

      <section className="details">
        <div className="details-container">
          <div className="details-text">
            <p>Detalles Clave del Evento</p>
          </div>

          <div className="details-banner">
            <div className="detail-item">
              <i className="fa-regular fa-calendar"></i>
              <div className="date">
                <span className="day">13</span>
                <span className="month">NOV</span>
              </div>
            </div>

            <span className="divider-vertical"></span>

            <div className="detail-item">
              <i className="fa-regular fa-clock"></i>
              <div className="hours">
                <span>08:00</span>
                <span>20:00</span>
              </div>
            </div>

            <span className="divider-vertical"></span>

            <div className="detail-item">
              <i className="fa-solid fa-location-dot"></i>
              <div className="place">
                <span>Auditorio Dr. William Morris</span>
                <span>UCSM - Arequipa</span>
              </div>
            </div>
          </div>


          <div className="details-bottom">
            <p>Entradas limitadas: Solo 400 cupos disponibles</p>
            <button className="btn-preventa" onClick={() => setIsOpen(true)}>VENTA</button>
          </div>
          {/* Popup */}
          <div className={`modal-overlay ${isOpen ? "show" : ""}`} onClick={() => setIsOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2 className="modal-title">🎟️ Entradas ConMujeres 2025 🎟️</h2>

              <div className="prices-grid">

                {/* General */}
                <div className="price-card">
                  <h3>General</h3>
                  <div className="price-values">
                    <p className="price-dates">PREVENTA</p>
                    <p className="price-dates">(10 Sept - 16 Oct)</p>
                    <span className="price-normal">S/ 210</span>
                  </div>
                  <p className="price-dates">TARIFA REGULAR</p>
                  <p className="price-dates">(01 Nov - 13 Nov)</p>
                  <div className="price-values">
                    <span className="price-preventa">S/ 280</span>
                  </div>
                </div>

                {/* Socios */}
                <div className="price-card">
                  <h3>Socios CCIA (-20%)</h3>
                  <div className="price-values">
                    <p className="price-dates">PREVENTA</p>
                    <p className="price-dates">(10 Sept - 16 Oct)</p>
                    <span className="price-normal">S/ 168</span>
                  </div>
                  <p className="price-dates">TARIFA REGULAR</p>
                  <p className="price-dates">(01 Nov - 13 Nov)</p>
                  <div className="price-values">
                    <span className="price-preventa">S/ 224</span>
                  </div>
                </div>

                {/* Estudiantes */}
                <div className="price-card">
                  <h3>Estudiantes</h3>
                  <div className="price-values">
                    <p className="price-dates">ÚNICO PRECIO</p>
                    <p className="price-dates">(Todo el periodo)</p>
                    <span className="price-preventa">S/ 80</span>
                  </div>
                </div>

              </div>

              <a
                href="https://wa.link/42028k"
                target="_blank"
                rel="noopener noreferrer"
                className="modal-btn"
              >
                Reservar por WhatsApp
              </a>

              <button className="modal-close" onClick={() => setIsOpen(false)}>✖</button>

            </div>
          </div>
        </div>
      </section>

      <img src="/images/conmu3-bg.jpg" alt="Fondo" className="bg-conmu" />


    </>
  );
}
